import { chains } from "@lens-chain/sdk/viem";
import { LENS_ENDPOINT } from "./lens-endpoints";
import { LENS_TREASURY } from "./lens-treasury";
import {
  MAINNET_CONTRACTS,
  TESTNET_CONTRACTS
} from "./contracts";
import getEnvConfig from "./utils/getEnvConfig";

// Lens and Hey Env Config
export const LENS_NETWORK = process.env.LENS_NETWORK || "mainnet";

// console.log("LENS_NETWORK:", LENS_NETWORK);

export const LENS_API_URL = getEnvConfig().lensApiEndpoint;
export const DEFAULT_COLLECT_TOKEN = getEnvConfig().defaultCollectToken;
export const SLICE_APP = getEnvConfig().appAddress;
export const CHAINS = getEnvConfig().chains;

export const SLICE_API_URL = process.env.SLICE_API_URL || "https://localhost:3000/";

export const IS_MAINNET = LENS_API_URL === LENS_ENDPOINT.Mainnet;
export const CHAIN = IS_MAINNET ? chains.mainnet : chains.testnet;
export const ADDRESS_PLACEHOLDER = "0x03Ba3...7EF";
export const NULL_ADDRESS = "0x0000000000000000000000000000000000000000";
export const SLICE_TREASURY = IS_MAINNET ? LENS_TREASURY.Mainnet : LENS_TREASURY.Testnet;

// Subscription
export const SUBSCRIPTION_AMOUNT = 100;

// Application
export const BRAND_COLOR = "#FB3A5D";

// URLs
export const STATIC_ASSETS_URL = "https://static.hey.xyz";
export const STATIC_IMAGES_URL = `${STATIC_ASSETS_URL}/images`;
export const LENS_MEDIA_SNAPSHOT_URL = "https://ik.imagekit.io/lens";
export const DEFAULT_AVATAR = "/default-avatar.png";
export const PLACEHOLDER_IMAGE = `${STATIC_IMAGES_URL}/placeholder.webp`;
export const BLOCK_EXPLORER_URL = IS_MAINNET
  ? "https://lenscan.io"
  : "https://testnet.lenscan.io";

// Storage
export const STORAGE_NODE_URL = "https://api.grove.storage";
export const IPFS_GATEWAY = "https://gw.ipfs-lens.dev/ipfs";
export const EVER_API = "https://endpoint.4everland.co";
export const EVER_REGION = "4EVERLAND";
export const EVER_BUCKET = "heyverse";

// Tokens / Keys
export const WALLETCONNECT_PROJECT_ID = "cd542acc70c2b548030f9901a52e70c8";
export const GIPHY_KEY = "yNwCXMKkiBrxyyFduF56xCbSuJJM8cMd"; // Read only safe key

export const LENS_NAMESPACE = "lens/";
export const NATIVE_TOKEN_SYMBOL = getEnvConfig().chains.lensChain.nativeToken.symbol;
export const WRAPPED_NATIVE_TOKEN_SYMBOL = IS_MAINNET ? "WGHO" : "WGRASS";
export const ERC20_TOKEN_SYMBOL = getEnvConfig().chains.lensChain.token.symbol;

export const MAX_IMAGE_UPLOAD = 8;

// Named transforms for ImageKit
export const TRANSFORMS = {
  ATTACHMENT: "tr:w-1000",
  AVATAR_BIG: "tr:w-350,h-350",
  AVATAR_SMALL: "tr:w-100,h-100",
  AVATAR_TINY: "tr:w-50,h-50",
  COVER: "tr:w-1350,h-350",
  EXPANDED_AVATAR: "tr:w-1000,h-1000"
} as const;

export const BANNER_IDS = {
  PRO: "66923664577042581083893709094038449217361505456682931841068198336764038176504"
} as const;

export const PERMISSIONS = {
  STAFF: "0xA7f2835e54998c6d7d4A0126eC0ebE91b5E43c69",
  SUBSCRIPTION: "0x780B6Db2237677554faDe2b20fC68005a9FD2064"
} as const;

export const BRIDGE_API_URL = process.env.BRIDGE_API_URL || "http://localhost:8787/";
export const PAYMENT_API_URL = process.env.PAYMENT_API_URL || "http://localhost:3000/";

export const BSC_POOL_CONTRACT =
  IS_MAINNET
    ? MAINNET_CONTRACTS.bscPool
    : TESTNET_CONTRACTS.bscPool;

export const LENS_BRIDGE_MINTER_CONTRACT =
  IS_MAINNET
    ? MAINNET_CONTRACTS.lensMinter
    : TESTNET_CONTRACTS.lensMinter;

export const TASK_ESCROW_POOL_ADDRESS =
  IS_MAINNET
    ? MAINNET_CONTRACTS.taskEscrowPool
    : TESTNET_CONTRACTS.taskEscrowPool;

export const ERC20_TOKEN_ADDRESS =
  IS_MAINNET
    ? MAINNET_CONTRACTS.defaultToken
    : TESTNET_CONTRACTS.defaultToken;

export const SUPER_APP_ORIGIN = 'https://mvp.dnpay.ai';